module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_03_sp-7e53543bd34d0fc5921d389aeddba3d9.png";